import {ClaimType} from '../../+ess/claims/claims.interfaces';
import {TreeNode} from '../ui';
import {groupBy} from '../utils/arrays';
import {at} from '../utils/objects';

export const getChildren = (types, type: string) => {
  return types[type].map(child => ({
    text: child.attributes.transId,
    value: child.attributes.name,
    data: child,
    selectable: true,
    visible: true,
    children: []
  }));
};

export const createClaimTypeTree = (claimTypes: ClaimType[]): Array<TreeNode<any>> => {
  const types = groupBy(claimTypes, element => at(element, 'attributes.familyTransId'));

  return Object.keys(types).map(familyTransId => ({
    text: familyTransId,
    value: familyTransId,
    data: familyTransId,
    selectable: false,
    visible: true,
    children: getChildren(types, familyTransId)
  }));
};
